var map = {
	"./biotechnology_1.png": "aAHU",
	"./biotechnology_2.png": "NOX7",
	"./biotechnology_thumbnail.jpg": "5OWL",
	"./genomics_clusters_1.png": "3Q5w",
	"./genomics_clusters_2.png": "6yPm",
	"./genomics_clusters_3.png": "5DtV",
	"./genomics_clusters_4.png": "7k+V",
	"./genomics_clusters_5.png": "U2Tx",
	"./genomics_thumbnail.jpg": "CDh+",
	"./nanoscience_1.png": "wj/0",
	"./nanoscience_2.png": "uO8x",
	"./nanoscience_3.png": "9SS5",
	"./nanoscience_thumbnail.jpg": "RIBX",
	"./openaccess_socialmedia_1.png": "aHV5",
	"./openaccess_socialmedia_2.png": "zf0S",
	"./openaccess_socialmedia_thumbnail.png": "zds5",
	"./region_distribution_1.png": "PG5k",
	"./region_distribution_2.png": "L1dA",
	"./region_distribution_3.png": "UEDU",
	"./region_distribution_thumbnail.jpg": "BE7I",
	"./science_technology_intensity_1.png": "Ovlf",
	"./science_technology_intensity_2.png": "+q1h",
	"./science_technology_intensity_3.png": "J+Ed",
	"./science_technology_intensity_4.png": "rKKo",
	"./science_technology_intensity_5.png": "0XL/",
	"./science_technology_intensity_thumbnail.jpg": "Iu9W"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9o9C";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories ^\.\/.*$
// module id = 9o9C
// module chunks = 6